'use strict';exports.__esModule = true;exports.currenciesOptions = exports.currencies = exports.getOptionsRentFilter = exports.getOptionsBuyFilter = exports.getOptionsFilter = exports.getOptionsConfig = undefined;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _reduxForm = require('redux-form');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _ramda = require('ramda');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _pick = require('lodash/pick');var _pick2 = _interopRequireDefault(_pick);
var _reactSelect = require('react-select');var _reactSelect2 = _interopRequireDefault(_reactSelect);


var _components = require('../../components');
var _containers = require('../../containers');


var _foreignPropertySearch = require('../../redux/modules/foreignPropertySearch');







var _constants = require('../../constants');





var _multiselectsTitles = require('../../utils/multiselectsTitles');
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _formatSearchBoxData = require('../../utils/formatSearchBoxData');
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _helpers = require('./helpers');var _helpers2 = _interopRequireDefault(_helpers);
var _slugify = require('../../helpers/slugify');var _slugify2 = _interopRequireDefault(_slugify);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _validate = require('./validate');var _validate2 = _interopRequireDefault(_validate);


var _ForeignSearchContainer = require('./ForeignSearchContainer.scss');var styles = _interopRequireWildcard(_ForeignSearchContainer);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
// Helpers
// Styles
var googleSearchConfig = { options: { defaultCountry: undefined, componentRestrictions: undefined },

  types: ['(regions)'] };


var possibleOptionTypes = {
  buy: _constants.optionTypes.buy,
  rent: _constants.optionTypes.rent + ',' + _constants.optionTypes['rent-short'],
  commercial: _constants.sections.commercial.location,
  projects: 'projects',
  residence: 'residence',
  all: 'all' };


var getPropTypesKey = function getPropTypesKey(option_type) {
  switch (option_type) {
    case possibleOptionTypes.buy:return _constants.sections.homes.value + '.buy';
    case possibleOptionTypes.rent:return _constants.sections.homes.value + '.rent';
    case possibleOptionTypes.projects:return _constants.sections.projects.value + '.buy';
    case possibleOptionTypes.commercial:return _constants.sections.commercial.value + '.buy';
    default:throw new Error('[Get prop types key] Unknown option type');}

};

var getSectionParam = function getSectionParam(option_type) {
  switch (option_type) {
    case possibleOptionTypes.buy:return null;
    case possibleOptionTypes.rent:return null;
    case possibleOptionTypes.projects:return '' + _constants.sections.projects.value;
    case possibleOptionTypes.commercial:return '' + _constants.sections.commercial.value;
    default:throw new Error('[Get section param] Unknown option type');}

};

var getOptionsConfig = exports.getOptionsConfig = function getOptionsConfig(translate) {return [
  { value: possibleOptionTypes.buy, label: translate('buy') },
  { value: possibleOptionTypes.rent, label: translate('rent') },
  { value: possibleOptionTypes.projects, label: translate('projects') },
  { value: possibleOptionTypes.commercial, label: translate('commercial') }];};


var getOptionsFilter = exports.getOptionsFilter = function getOptionsFilter(translate) {return [
  { value: possibleOptionTypes.buy, label: translate('buy') },
  { value: possibleOptionTypes.rent, label: translate('rent') }];};


var getOptionsBuyFilter = exports.getOptionsBuyFilter = function getOptionsBuyFilter(translate) {return [
  { value: possibleOptionTypes.all, label: translate('all') },
  { value: possibleOptionTypes.residence, label: translate('residence') },
  { value: possibleOptionTypes.commercial, label: translate('commercial') },
  { value: possibleOptionTypes.projects, label: translate('projects') }];};


var getOptionsRentFilter = exports.getOptionsRentFilter = function getOptionsRentFilter(translate) {return [
  { value: possibleOptionTypes.all, label: translate('all') },
  { value: possibleOptionTypes.residence, label: translate('residence') },
  { value: possibleOptionTypes.commercial, label: translate('commercial') }];};


var currencies = exports.currencies = {
  ILS: 'ILS',
  USD: 'USD',
  EUR: 'EUR' };


var currenciesOptions = exports.currenciesOptions = [
{ label: '₪', value: currencies.ILS },
{ label: '$', value: currencies.USD },
{ label: '€', value: currencies.EUR }];var


ForeignSearchContainer = function (_Component) {_inherits(ForeignSearchContainer, _Component);function ForeignSearchContainer() {var _temp, _this, _ret;_classCallCheck(this, ForeignSearchContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      сlearInputLocation: false }, _this.














    formatPriceParameters = function (field) {return {
        value: (0, _get2.default)(_this.props, ['fields', field]),
        onChange: function onChange(value) {return _this.handleChange([field], value);} };}, _this.


    handleOptionChange = function (value) {
      _this.handleChange('option_type', value);
    }, _this.

    handleChange = function (name, value) {return _this.props.change(name, value);}, _this.

    sendRequest = function (values) {
      var params = (0, _helpers2.default)(values);
      params.section = getSectionParam(_this.props.fields.option_type);

      var country = (0, _slugify2.default)(params.country || '');
      var query = (0, _omit2.default)(params, ['country']);
      var requestType = values.option_type === 'projects' ? 'projects' : 'properties';var
      option = params.option,section = params.section,restParams = _objectWithoutProperties(params, ['option', 'section']);

      _reactRouter.browserHistory.push({
        pathname: (0, _appendLocale2.default)(
        _this.props.locale, '/' +
        _constants.ROUTES_PATHS.FOREIGN + '/' + country + '/' + _constants.ROUTES_ADDITIONAL.FOREIGN_SEARCH),

        query: query });


      _this.props.searchForeignProperties({
        requestType: requestType,
        params: Object.assign({},
        section === 'projects' ? restParams : params, {
          $skip: 0,
          $limit: 20,
          $sort: '-created_at' }) });


      _this.props.countForeignProperties({ params: section === 'projects' ? restParams : params });
      _this.props.saveSearchedForeignAddress(values.address);
    }, _this.

    renderLocationInput = function (_ref) {var _cx;var input = _ref.input,meta = _ref.meta;
      var clearAddress = function clearAddress() {return input.onChange(null);};
      var handleChange = function handleChange(address) {
        input.onChange(address);
        if (!_this.props.foreignPropertySearch.searchedAddress) {
          var _initialAddress = (0, _get2.default)(_this.props, 'initialValues.address');
          if (!_initialAddress || address !== _initialAddress) {
            _this.props.saveSearchedForeignAddress(address);
          }
        }
      };

      var separator = _this.props.city ? ', ' : '';
      var initialAddress = ('' + (_this.props.city || '') + separator + (_this.props.country || '')).
      replace(/-/gi, ' ');

      var isInvalid = meta.touched && meta.error && !meta.active;

      var locusSearchConfig = {
        overseasOnly: true,
        locale: _this.props.locale };


      return (
        _react2.default.createElement(_components.HomePageLocationInput, {
          сlearInputLocation: _this.state.сlearInputLocation,
          placeholder: '' + _this.props.translate('searchContainer', 'regionPlaceholder'),
          locale: _this.props.locale,
          getInputData: handleChange,
          clearInput: clearAddress,
          initialAddress: initialAddress,
          googleSearchConfig: googleSearchConfig,
          locusSearchConfig: locusSearchConfig,
          className: (0, _classnames2.default)((_cx = {}, _cx[styles.requiredAddress] = isInvalid, _cx)),
          onBlur: input.onBlur,
          onFocus: input.onFocus,
          isForeign: true }));


    }, _this.

    renderCurrencySelect = function (_ref2) {var input = _ref2.input,meta = _ref2.meta;return (
        _react2.default.createElement(_reactSelect2.default, _extends({},
        input, {
          options: currenciesOptions,
          searchable: false,
          clearable: false,
          instanceId: 'currency',
          placeholder: _this.props.translate('currency').toString(),
          className: (0, _classnames2.default)(styles.currencySelect,
          { not_valid: meta.touched && meta.error && !meta.active }) })));}, _this.



    renderAddressField = function () {return (
        _react2.default.createElement(_reduxForm.Field, {
          name: 'address',
          locale: _this.props.locale,
          initialAddress: _this.props.city + ' ' + _this.props.country,
          component: _this.renderLocationInput }));}, _this.



    renderPropertyTypesField = function () {
      var renderPropertyTypeInput = function renderPropertyTypeInput(_ref3) {var input = _ref3.input;var _this$props =
        _this.props,rootTranslate = _this$props.rootTranslate,propertyTypes = _this$props.propertyTypes,fields = _this$props.fields;var _fields$option_type =
        fields.option_type,option_type = _fields$option_type === undefined ? _constants.defaultOptionType : _fields$option_type,_fields$property_type = fields.property_types,property_types = _fields$property_type === undefined ? [] : _fields$property_type;
        var propertyValue = typeof property_types === 'string' ? [property_types] : property_types;
        var propTypesKey = getPropTypesKey(option_type);
        var currentPropertyTypes = (0, _get2.default)(propertyTypes, propTypesKey);
        var typesInput = (0, _formatSearchBoxData.formatTypes)(currentPropertyTypes, rootTranslate, false, option_type);
        var typesTitle = (0, _multiselectsTitles.propertyTypesTitle)(propertyValue, rootTranslate);

        return (
          _react2.default.createElement(_containers.MultiselectWrapper, {
            className: styles.multiSelects,
            options: typesInput,
            title: typesTitle,
            value: propertyValue,
            onChange: input.onChange }));


      };
      return (
        _react2.default.createElement(_reduxForm.Field, {
          name: 'property_types',
          locale: _this.props.locale,
          component: renderPropertyTypeInput }));


    }, _this.

    renderPricesField = function () {return (
        _react2.default.createElement(_components.MinMaxPrices, {
          translate: _this.props.translate('searchContainer'),
          minPrice: _this.formatPriceParameters('min_price'),
          maxPrice: _this.formatPriceParameters('max_price'),
          className: styles.minMaxPrice }));}, _this.



    renderCurrencyField = function () {return (
        _react2.default.createElement(_reduxForm.Field, {
          name: 'currency',
          locale: _this.props.locale,
          component: _this.renderCurrencySelect }));}, _this.



    renderDesktopForm = function () {return (
        _react2.default.createElement(_reduxForm.Form, { className: styles.formWrapper, onSubmit: _this.props.handleSubmit(_this.sendRequest) },
          _react2.default.createElement('div', { className: styles.titlesRow },
            _react2.default.createElement('div', { className: styles.longItem }, _this.props.translate('searchContainer', 'region')),
            _react2.default.createElement('div', { className: styles.longItem }, _this.props.translate('searchContainer', 'propertyTypesTitle')),
            _react2.default.createElement('div', { className: styles.shortItem }, _this.props.translate('searchContainer', 'minPriceTitle')),
            _react2.default.createElement('div', { className: styles.shortItem }, _this.props.translate('searchContainer', 'maxPriceTitle')),
            _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.shortItem, styles.shortItemCurrency) },
              _this.props.translate('searchContainer', 'currency'))),


          _react2.default.createElement('div', { className: styles.formRow },
            _react2.default.createElement('div', { className: styles.formControls },
              _react2.default.createElement('div', { className: styles.locationWrapper },
                _this.renderAddressField()),

              _react2.default.createElement('div', { className: styles.multiSelectWrapper },
                _this.renderPropertyTypesField()),

              _react2.default.createElement('div', { className: styles.pricesWrapper },
                _this.renderPricesField(),
                _this.renderCurrencyField())),


            _react2.default.createElement('button', { className: styles.searchButton, type: 'button', onClick: _this.props.submit },
              _react2.default.createElement('span', { className: 'icon icon-search' })))));}, _this.





    renderMobileForm = function () {return (
        _react2.default.createElement(_reduxForm.Form, { className: styles.formWrapper, onSubmit: _this.props.handleSubmit(_this.sendRequest) },
          _react2.default.createElement('div', { className: styles.locationWrapper },
            _react2.default.createElement('div', { className: styles.rowTitle }, _this.props.translate('searchContainer', 'region')),
            _react2.default.createElement('div', { className: styles.searchRow },
              _this.renderAddressField(),
              _react2.default.createElement('button', { className: styles.searchButton, type: 'button', onClick: _this.props.submit },
                _react2.default.createElement('span', { className: 'icon icon-search' })))),




          _react2.default.createElement('div', { className: styles.multiSelectWrapper },
            _react2.default.createElement('div', { className: styles.rowTitle }, _this.props.translate('searchContainer', 'propertyTypesTitle')),
            _this.renderPropertyTypesField()),


          _react2.default.createElement('div', { className: styles.pricesWrapper },
            _react2.default.createElement('div', { className: styles.priceTitles },
              _react2.default.createElement('div', { className: styles.rowTitle }, _this.props.translate('searchContainer', 'minPriceTitle')),
              _react2.default.createElement('div', { className: styles.rowTitle }, _this.props.translate('searchContainer', 'maxPriceTitle')),
              _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.rowTitle, styles.rowTitleCurrency) },
                _this.props.translate('searchContainer', 'currency'))),



            _this.renderPricesField(),
            _this.renderCurrencyField())));}, _temp), _possibleConstructorReturn(_this, _ret);}ForeignSearchContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref4) {var routing = _ref4.routing,locale = _ref4.locale;if (routing.pathname !== this.props.routing.pathname) {this.setState({ сlearInputLocation: false });}if (routing.pathname !== this.props.routing.pathname && routing.pathname === '/' + locale + '/foreign') {this.setState({ сlearInputLocation: true });this.props.clearAddressData();}};ForeignSearchContainer.prototype.




  render = function render() {var _props =
    this.props,translate = _props.translate,isMobile = _props.isMobile,fields = _props.fields;var
    option_type = fields.option_type;

    // const TabsComponent = isMobile ? OMRadioButtonsShortRow : OMRadioButtonsRow;

    return (
      _react2.default.createElement('div', { className: styles.searchBoxContainer },
        _react2.default.createElement(_components.OMRadioButtonsRow, {
          onChange: this.handleOptionChange,
          selectedValue: option_type,
          name: 'search-box-options',
          values: getOptionsConfig(translate) }),

        isMobile ? this.renderMobileForm() : this.renderDesktopForm()));


  };return ForeignSearchContainer;}(_react.Component);


ForeignSearchContainer.propTypes = {
  country: _propTypes2.default.string,
  city: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  propertyTypes: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  fields: _propTypes2.default.object,
  change: _propTypes2.default.func,
  submit: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  searchForeignProperties: _propTypes2.default.func,
  countForeignProperties: _propTypes2.default.func,
  saveSearchedForeignAddress: _propTypes2.default.func,
  foreignPropertySearch: _propTypes2.default.object,
  countriesList: _propTypes2.default.array,
  clearAddressData: _propTypes2.default.func,
  routing: _propTypes2.default.object };


var selector = (0, _reduxForm.formValueSelector)('foreignSearchContainer');

var mapStateToProps = function mapStateToProps(state) {return {
    rootTranslate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    translate: (0, _reduxPagan.getLang)(state.lang, 'static', 'search_box'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    propertyTypes: state.propertyTypes.sorted || {},
    countriesList: state.countries.data || [],
    foreignPropertySearch: state.foreignPropertySearch,
    routing: (0, _get2.default)(state, 'routing.locationBeforeTransitions'),
    city: (0, _get2.default)(state, 'foreignPropertySearch.query.city'),
    fields: {
      address: selector(state, 'address'),
      option_type: selector(state, 'option_type'),
      property_types: selector(state, 'property_types'),
      min_price: selector(state, 'min_price'),
      max_price: selector(state, 'max_price'),
      currency: selector(state, 'currency') },

    initialValues: {
      address: (0, _get2.default)(state, 'foreignPropertySearch.searchedAddress'),
      option_type: (0, _get2.default)(state, 'routing.locationBeforeTransitions.query.option') || selector(state, 'option_type') || _constants.defaultOptionType,
      property_types: (0, _get2.default)(state, 'routing.locationBeforeTransitions.query.type'),
      min_price: (0, _get2.default)(state, 'routing.locationBeforeTransitions.query.min'),
      max_price: (0, _get2.default)(state, 'routing.locationBeforeTransitions.query.max'),
      currency: (0, _get2.default)(state, 'routing.locationBeforeTransitions.query.currency') || currencies.USD } };};exports.default =



(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, {
  searchForeignProperties: _foreignPropertySearch.searchForeignProperties,
  countForeignProperties: _foreignPropertySearch.countForeignProperties,
  saveSearchedForeignAddress: _foreignPropertySearch.saveSearchedForeignAddress,
  clearAddressData: _foreignPropertySearch.clearAddress }),

(0, _reduxForm.reduxForm)({
  form: 'foreignSearchContainer',
  enableReinitialize: true,
  validate: _validate2.default }))(

ForeignSearchContainer);


//////////////////
// WEBPACK FOOTER
// ./src/containers/ForeignSearchContainer/ForeignSearchContainer.js
// module id = 571
// module chunks = 0